export enum SocketEventsEnum {
    JOIN_ROOM = 'join-room',
    CALL_REQUEST = 'call-request',
    CALL_INCOMING = 'call-incoming',
    CALL_ANSWER = 'call-answer',
}